<template>
  <div class="patentInfo">
    <el-scrollbar>
      <div class="cont">
        <div class="cont-main col999">
          <el-collapse v-model="activeCollNames" accordion>
            <el-collapse-item name="1" disabled>
              <template #title>
                <div class="updateBox flex-between">
                  <div class="type">
                    <div class="tit" @click="handleChange">
                      <span>长期医嘱</span>
                      <i class="fa fa-angle-right" :class="!activeCollNames ? 'bottom' : ''"></i>
                    </div>
                    <el-radio-group v-model="searchData.use_flag" @change="getDataList" v-if="activeCollNames">
                      <el-radio-button label="1">在用</el-radio-button>
                      <el-radio-button label="0">停用</el-radio-button>
                    </el-radio-group>
                    <el-radio-group v-model="searchData.dict_advice_type" @change="getDataList" v-if="activeCollNames">
                      <el-radio-button label="">全部</el-radio-button>
                      <el-radio-button label="163110000">药疗</el-radio-button>
                      <!-- <el-radio-button label="2">检验</el-radio-button> -->
                      <el-radio-button label="163120000">处置</el-radio-button>
                    </el-radio-group>
                  </div>
                  <div class="upButtom" v-if="activeCollNames">
                    <el-button-group>
                      <el-button type="success" @click="openWeight('addLongIerm', '0')">新增医嘱</el-button>
                      <el-button type="primary" @click="addTao('addLongIerm')">导入组套</el-button>
                      <el-button type="primary" @click="delData()">批量删除</el-button>
                    </el-button-group>
                  </div>
                </div>
              </template>
              <div class="tables">
                <el-table v-loading="dataListLoading" @selection-change="handleSelectionChange"  :data="tableData" class="table-ellipsis" size="small" border
                  max-height="300px">
                  <el-table-column type="selection" align="center" width="42" />
                  <el-table-column width="60" fixed prop="dict_advice_type_name" label="类别" />
                  <el-table-column width="280" prop="advice_content" label="医嘱内容" show-overflow-tooltip />
                  <el-table-column width="100" label="单次剂量">
                    <template #default="scope">
                      <span>
                        {{ scope.row.dosage }}{{ scope.row.dict_dosage_unit_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="100" label="用药途径" property="dict_use_way_name">
                  </el-table-column>
                  <el-table-column width="70" prop="num" label="数量" />
                  <el-table-column width="120" prop="medi_spec" label="规格"></el-table-column>
                  <el-table-column width="80" property="name" label="包装">
                    <template #default="scope">
                      <span>
                        {{ scope.row.min_package_num }}{{ scope.row.min_unit_name }}/{{ scope.row.min_package_unit_name
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" property="company" label="厂家" show-overflow-tooltip />
                  <el-table-column width="100" label="库存">
                    <template #default="scope">
                      <template v-if="scope.row.is_drug || scope.row.is_material">
                        <template v-if="scope.row.store_num">
                          {{ scope.row.store_num }}{{ scope.row.min_package_unit_name }}
                        </template>
                        <template v-if="scope.row.store_sub_num">
                          {{ scope.row.store_sub_num }}{{ scope.row.min_unit_name }}
                        </template>
                      </template>
                      <template v-else>--</template>
                    </template>
                  </el-table-column>
                  <el-table-column width="100" prop="doctor.name" label="开嘱医生" />
                  <el-table-column width="180" prop="start_time" label="开嘱时间" />
                  <el-table-column prop="remark" label="备注" show-overflow-tooltip />
                  <el-table-column fixed="right" label="操作" width="280" align="center">
                    <template #default="scope">
                      <el-link type="warning" v-if="searchData.use_flag === '1'"
                        @click="deatilsClick(scope.row)">停用</el-link>
                      <el-link type="primary" v-if="searchData.use_flag === '1'"
                        @click="modParient(scope.row)">修改</el-link>
                      <el-link type="danger" @click="delParient(scope.row)">删除</el-link>
                      <el-link type="success" v-if="searchData.use_flag === '1'"
                        @click="addTemporary(scope.row)">添加临时医嘱</el-link>
                      <el-link type="primary" @click="sortData(scope.row, 1)"><el-icon>
                          <Top />
                        </el-icon></el-link>
                      <el-link type="primary" @click="sortData(scope.row, 2)"><el-icon>
                          <Bottom />
                        </el-icon></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-scrollbar>
    <BaseDialog title="停用" :isshow="visibleItem" @handleShow="handleShow" width="600px" top="20%">
      <div class="tongluBox">
        <el-form :model="stupData" label-width="110px" label-position="right" class="demo-ruleForm col-333">
          <el-form-item label="停用原因:">
            <el-input v-model="stupData.group_name" placeholder="请输入停用原因" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="visibleItem = false">
            取消
          </el-button>
          <el-button @click="accessItem" :loading="saveLoad" class="color-determine" type="primary">
            保存
          </el-button>
        </div>
      </template>
    </BaseDialog>
    <batchLongIerm v-if="isBatchLongIerm" ref="batchLongIermRef" :patientId="patientId" @refreshDataList="getDataList">
    </batchLongIerm>
    <addLongIerm v-if="isAddLongIerm" ref="addLongIermRef" :patientId="patientId" @refreshDataList="getDataList">
    </addLongIerm>
    <viewLongIerm v-if="isViewLongIerm" ref="viewLongIermRef" :patientId="patientId" @refreshDataList="getDataList">
    </viewLongIerm>
    <changQi ref="changQiRef"> </changQi>
    <addTaoModal v-if="isAddTao" ref="addTaoModalRef" :patientId="patientId" @refreshDataList="getDataList">
    </addTaoModal>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, nextTick, watch, getCurrentInstance } from 'vue'
import { getConstHei } from '@/utils/tool.js'
import service from '@/utils/request'
import { ElMessage, ElMessageBox, MessageBox } from 'element-plus'
import batchLongIerm from '@/views/patient/Details/advice/batchLongIerm.vue'
import addLongIerm from '@/views/patient/Details/advice/addLongIerm.vue'
import viewLongIerm from './viewLongIerm.vue'
import BaseDialog from '@/components/Dialog/index.vue'
import changQi from './changQi.vue'
import addTaoModal from './addTaoModal'
export default {
  name: 'programme',
  components: {
    batchLongIerm,
    addLongIerm,
    BaseDialog,
    viewLongIerm,
    changQi,
    addTaoModal
  },
  props: ['patientData', 'searchListData'],
  emits: ['addCallback'],
  setup(props, ctx) {
    const { proxy } = getCurrentInstance()
    const state = reactive({
      ruleForm: {},
      infoHei: '',
      searchData: {
        is_preopen: '0',
        use_flag: '1',
        dict_advice_type: '',
        scene: 'report',
      },
      tableData: [],
      pageData: {
        currentPage: 1,
        pageSize: 20,
        totalSum: 0,
      },
      dataListLoading: false,
      isBatchLongIerm: false,
      batchLongIermRef: null,
      isAddLongIerm: false,
      isAddTao: false,
      isViewLongIerm: false,
      addLongIermRef: null,
      viewLongIermRef: null,
      addTaoModalRef: null,
      stupData: {},
      visibleItem: false,
      saveLoad: false,
      patientId: 0,
      record_id: 0,
      activeCollNames: '1',
      showTip: false,
      tableSelected:[]
    })

    watch(
      () => props.patientData.patient_id,
      (val) => {
        if (val) {
          state.patientId = val
          state.record_id = props.patientData.record_id
        } else {
          state.patientId = 0
          state.record_id = 0
        }
        getDataList()
      }
    )

    onMounted(() => {

      state.infoHei = getConstHei()
      if (props.patientData.patient_id) {
        state.patientId = props.patientData.patient_id
        state.record_id = props.patientData.record_id
      } else {
        state.patientId = 0
        state.record_id = 0
      }
      getDataList()
    })
    const getDataList = async () => {
      state.searchData.patient_id = state.patientId
      state.searchData.current = state.pageData.currentPage
      state.searchData.size = state.pageData.pageSize
      state.dataListLoading = true
      let res = await service.post('/api/advice/list', state.searchData)
      state.dataListLoading = false
      if (res.code === 0) {
        state.tableData = res.data.records
        state.pageData.totalSum = res.data.total
      }
    }

    const handleSizeChange = (val) => {
      state.pageData.pageSize = val
      getDataList()
    }

    const handleCurrentChange = (val) => {
      state.pageData.currentPage = val
      getDataList()
    }

    const openWeight = (type, val) => {
      if (!state.patientId || state.patientId === 0) {
        ElMessage({
          message: '请先选择患者',
          type: 'warning',
        })
        return
      }
      switch (type) {
        case 'batchLongIerm':
          state.isBatchLongIerm = true
          nextTick(() => {
            state.batchLongIermRef.initData()
          })
          break
        case 'addLongIerm':
          state.isAddLongIerm = true
          nextTick(() => {
            state.addLongIermRef.initData('', val)
          })
          break
      }
    }

    const addTao = () => {
      state.isAddTao = true
      nextTick(() => {
        state.addTaoModalRef.initData('chang', '')
      })
    }


    const cycleFiler = (item) => {
      if (!item) return
      let row = []
      item.forEach((el) => {
        if (el === 'monday') {
          row.push('周一')
        }
        if (el === 'tuesday') {
          row.push('周二')
        }
        if (el === 'wednesday') {
          row.push('周三')
        }
        if (el === 'thursday') {
          row.push('周四')
        }
        if (el === 'friday') {
          row.push('周五')
        }
        if (el === 'saturday') {
          row.push('周六')
        }
        if (el === 'sunday') {
          row.push('周日')
        }
      })
      return row.sort().join(',')
    }

    const handleShow = (val) => {
      state.visibleItem = val
    }

    const deatilsClick = (item) => {
      state.stupData.id = item.id
      state.stupData.group_name = ''
      state.visibleItem = true
    }
    const accessItem = async () => {
      state.saveLoad = true
      let res = await service.post('/api/advice/stop', state.stupData)
      state.saveLoad = false
      if (res.code === 0) {
        ElMessage.success(res.msg)
        state.visibleItem = false
        getDataList()
      }
    }
    const modParient = (item) => {
      state.isViewLongIerm = true
      nextTick(() => {
        state.viewLongIermRef.initData(item, '0', '')
      })
    }
    const delParient = (item) => {
      ElMessageBox.confirm('删除后无法撤销，确认删除吗？', '操作提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await service.post('/api/advice/delete', {
            id: item.id,
          })
          if (res.code === 0) {
            ElMessage.success(res.msg)
            getDataList()
          }
        })
        .catch(() => { })
    }
    const doThing = async (code, item) => {
      let res = await service.post('api/dialysis_record/checkSettleStatus', {
        bed_id: props.patientData.id,
      })
      if (res.code === 0) {
        if (res.data.is_settle) {
          if (code == 1) {
            let param = item
            param.id = ''
            param.record_id = state.record_id
            let res = await service.post('/api/dialysis_record/create_tmp', param)
            if (res.code === 0) {
              ElMessage.success(res.msg)
              ctx.emit('addCallback')
            }
          }

        } else {
          ElMessage.error('请先撤销结算')
        }

      }
    }
    // 添加到临时医嘱
    const addTemporary = async (item) => {
      doThing('1', item)
    }
    //调整顺序
    const sortData = async (row, code) => {
      let param = {
        id: row.id,
        type: code
      }
      let res = await service.post('/api/advice/sort_patient_advice', param)
      if (res.code === 0) {
        ElMessage.success(res.msg)
        getDataList()
      }
    }
    const handleChange = () => {
      if (state.activeCollNames) {
        state.activeCollNames = ''
      } else {
        state.activeCollNames = '1'
      }
    }
    const handleSelectionChange = (e)=>{
      console.log(e)
      state.tableSelected = e
    }
    const delData = ()=>{
      if(state.tableSelected.length>0){
          let ids = state.tableSelected.map((e)=> e.id)
          ElMessageBox.confirm('共' + ids.length + '条医嘱，确认全部删除吗？', '操作提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let data = {
              id_list:ids
            }
            let res = await service.post('/api/advice/deleteMulti', data)
            if (res.code === 0) {
              ElMessage.success(res.msg)
              getDataList()
              state.tableSelected = []
            }
          })
          .catch(() => {
          })
      }else{
        ElMessage.error('请选择要删除的医嘱！')
      }
    }
    const print = async () => {
      state.searchData.patient_id = state.patientId
      state.searchData.current = 1
      state.searchData.size = 1000
      state.dataListLoading = true
      let res = await service.post('/api/advice/list', state.searchData)
      state.dataListLoading = false
      if (res.code === 0) {
        if (res.data.records.length > 0) {
          let data = {
            name: props.patientData.patient.name,
            age: props.patientData.patient.age,
            dict_sex_name: props.patientData.patient.dict_sex_name,
            drug_list: res.data.records
          }
          proxy.$refs.changQiRef.initData(data)
          nextTick(() => {
            proxy.$refs.changQiRef.print()
          })
        } else {
          ElMessage.error('暂无打印信息！')
        }
      }

    }
    return {
      ...toRefs(state),
      openWeight,
      getDataList,
      accessItem,
      deatilsClick,
      modParient,
      delParient,
      handleShow,
      handleSizeChange,
      handleCurrentChange,
      cycleFiler,
      handleChange,
      addTemporary,
      print,
      addTao,
      sortData,
      doThing,
      handleSelectionChange,
      delData
    }
  },
}
</script>

<style scoped lang="scss">

.cont {
  &:deep(.el-collapse) {
    .el-collapse-item__content {
      padding-bottom: 10px;
    }
  }
}

.el-link {
  margin-right: 8px;
}

.patentInfo {
  margin-top: 8px;
}

.podBot {
  padding-bottom: 30px;
}

.updateBox {
  height: 36px;
  width: 100%;
  align-items: center;

  .el-radio-group {
    margin-right: 30px;
  }

  .type {
    display: flex;
    align-items: center;

    .tit {
      display: inline-block;
      font-size: 18px;
      color: #000000;
      line-height: 32px;
      margin-right: 20px;
      cursor: pointer;

      .fa {
        font-size: 24px;
        margin-left: 10px;
        color: #999999;
        transition: transform 0.3s;

        &.bottom {
          transform: rotate(90deg);
        }
      }
    }
  }
}

.cont-main {
  &:deep(.el-collapse-item__arrow) {
    width: 0;
  }

  &:deep(.el-collapse-item__header) {
    border-bottom: 0;
    cursor: default;
  }
}


.parient-tag {
  .el-tag {
    margin-right: 10px;
  }
}

.tongluBox {
  margin-top: 20px;
}</style>